import { Fragment } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Forums from 'pages/forums/index';
import About from 'components/about';
import ChinhSachBaoMat from 'components/chinh_sach_bao_mat';
import QuyCheHoatDong from 'components/quy_che_hoat_dong';
import TranhChapKhieuNai from 'components/tranh_chap_khieu_nai';
import Contact from 'components/contact';
import TwoNongMarket from 'pages/market/index';
import ProductDetail from 'pages/ProductDetail/index';
import Auth from 'components/auth';
import Articles from 'pages/articles/index';
import NotFound from 'components/not_found';
import PrivacyPolicy from 'components/privacy_policy';
import TermsCondition from 'components/terms_condition';
import ArticleDetail from 'pages/articleDetail/index';
import Diagnostic from 'containers/diagnostic';
import ProductCatalogues from 'pages/productCatalogues/index';
import Videos from 'pages/videos/index';
import ShopProfile from 'containers/shop_profile';
import DiagnosticDetail from 'components/diagnostic_detail';
import Sitemap from 'components/sitemap';
import PrivateRoutes from 'services/privateRouter';
// quy trinh ky thuat
import TechnicalProcess from 'pages/technical_process';
import ContributeTechnicalProcess from 'pages/technical_process/components/contributeTechnical';
import CatalogueDetail from 'pages/technical_process/components/CatalogueDetail';
// shop qua tang
import ShopGift from 'pages/GiftStore/index';
import PointsTransaction from 'pages/pointsTransaction/storeGiftDetail';
import GiftReceiveDetail from '../pages/GiftReceiveDetail';
// invoice detail public
import DetailInvoiceNotAuthen from '../pages/InvoiceDetail/DetailInvoiceNotAuthen';

// business association
import BusinessAction from '../pages/BusinessAssociation/BusinessAction/index';
import BusinessProduct from '../pages/BusinessAssociation/BusinessProduct/index';
import AddEditBusinessProduct from '../pages/BusinessAssociation/BusinessProduct/AddEdit';
import BusinessInvoice from '../pages/BusinessAssociation/BusinessInvoice/index';
import DetailRefundBusinessInvoice from 'pages//BusinessAssociation/BusinessInvoiceDetail/DetailRefundBusinessInvoice';
import BusinessInvoiceDetail from '../pages/BusinessAssociation/BusinessInvoiceDetail/index';
import BusinessEmployee from '../pages/BusinessAssociation/BusinessEmployee';
import BusinessDetail from 'pages/BusinessAssociation/BusinessAssociationDetail/index';
import TechnicalProcessDetail from '../pages/TechnicalProcessDetail/index.jsx';
import VideoDetail from '../pages/VideoDetail';
import Banner from '../components/Banner';
import BannerDetail from '../pages/BannerDetail/BannerDetail';
import AllEnterPrises from '../pages/Enterprises';
import EnterpriseDetail from '../pages/EnterpriseDetail';
import BusinessCreateShipping from '../pages/createShipping/businessCreateShipping.jsx';
import ModulesRoutes from './modulesRoutes.js';
import PostsRoutes from './postsRoutes.js';
import UsersRoutes from './usersRoutes.js';
import RewriteUrlComponent from '../components/RewriteUrlComponent.jsx';

function Routers() {
  const location = useLocation();
  const state = location.state;
  return (
    <Fragment>
      <ModulesRoutes />
      <UsersRoutes />
      <Routes location={state?.backgroundLocation || location}>
        <Route path="/*" element={<PostsRoutes />} />
        {/* Các định nghĩa route khác */}
        <Route path="/" element={<Forums />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cho-2nong" element={<TwoNongMarket />}>
          <Route path="nong-san" element={<TwoNongMarket />} />
          <Route path="vat-tu-nong-nghiep" element={<TwoNongMarket />} />
          <Route path="nong-nghiep-do-thi" element={<TwoNongMarket />} />
          <Route path="nha-san-xuat" element={<TwoNongMarket />} />
        </Route>
        <Route path="/danh-sach-doanh-nghiep" element={<AllEnterPrises />} />
        <Route path="/doanh-nghiep/:slug" element={<EnterpriseDetail />} />
        <Route path="/san-pham/:productId" element={<ProductDetail />} />
        <Route path="/san-pham/danh-muc/:catalogueId" element={<ProductCatalogues />} />
        <Route path="/tin-tuc/:articleId" element={<ArticleDetail type="Article" />} />
        <Route path="/tin-tuc" element={<Articles />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/diagnostics" element={<Diagnostic />} />
        <Route path="/diagnostics/:diagnosticsId" element={<DiagnosticDetail />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/short_videos/:shortVideoId" element={<RewriteUrlComponent />} />
        <Route path="/video-ngan/:shortVideoId" element={<VideoDetail />} />
        <Route path="/quang-cao/:bannerId" element={<BannerDetail />} />
        <Route path="/videos/:articleId" element={<ArticleDetail type="Video" />} />
        <Route path="/sitemap" element={<Sitemap />} />

        <Route>
          <Route path="/quy-trinh-ky-thuat" element={<TechnicalProcess />} />
          <Route path="/dong-gop-quy-trinh-ky-thuat" element={<ContributeTechnicalProcess />} />
          <Route path="/quy-trinh-ky-thuat/danh-muc/:categoryId" element={<CatalogueDetail />} />
          <Route path="/quy-trinh-ky-thuat/chi-tiet/:technicalProcessId" element={<TechnicalProcessDetail />} />
        </Route>
        <Route path="/about" element={<About />} />
        <Route path="/chinh-sach-bao-mat" element={<ChinhSachBaoMat />} />
        <Route path="/quy-che-hoat-dong" element={<QuyCheHoatDong />} />
        <Route path="/tranh-chap-khieu-nai" element={<TranhChapKhieuNai />} />

        <Route path="/"></Route>
        <Route path="/chi-tiet-nhan-thuong" element={<GiftReceiveDetail />} />
        <Route path="/shop-qua-tang" element={<ShopGift />} />
        <Route path="/nhat-ky-doi-qua" element={<PointsTransaction />} />
        <Route path="/cua-hang/:userId" element={<ShopProfile />} />
        <Route path="/don-hang/:invoiceId" element={<DetailInvoiceNotAuthen />} />
        <Route element={<PrivateRoutes />}>
          <Route path="/lien-ket-danh-nghiep">
            <Route path="chuc-nang/:businessId" element={<BusinessAction />} />
            <Route path="san-pham/:businessId" element={<BusinessProduct />} />
            <Route path="san-pham/:businessId/tao-moi" element={<AddEditBusinessProduct />} />
            <Route path="san-pham/chinh-sua/:productId/business/:businessId" element={<AddEditBusinessProduct />} />
            <Route path="don-hang/danh-sach-don-hang/:businessId" element={<BusinessInvoice />} />
            <Route path="thong-tin-don-hang/:invoiceId/business/:businessId" element={<BusinessInvoiceDetail />} />
            <Route
              path="thong-tin-don-hang-hoan-tra/:invoiceId/business/:businessId"
              element={<DetailRefundBusinessInvoice />}
            />
            <Route
              path="thong-tin-don-hang/:invoiceId/business/:businessId/van-don"
              element={<BusinessCreateShipping type="sales" />}
            />
            <Route path="nhan-vien/:businessId" element={<BusinessEmployee />} />
            <Route path="thong-tin-danh-nghiep/:businessId" element={<BusinessDetail />} />
          </Route>
        </Route>
      </Routes>

      <Banner location={location} />
    </Fragment>
  );
}

export default Routers;
